export { default } from './ProductBadge';
